import { useListUserCauseSelections } from '@givebacks/api/core';
import { Modal, ModalProps, Stack, Text } from 'ui';

import {
  TransferAccountModalTitleWithBackButton,
  useTransferAccountsModalGroupProvider,
} from '../../../organisms/modals/TransferAccountsModalGroup/TransferAccountModalGroup.context';
import { MyCauseCard } from '../../MyCauseCard/MyCauseCard';

const SelectCauseModalContent = () => {
  const { openModalById, setMeta } = useTransferAccountsModalGroupProvider({});
  const { data: userCauseSelections } = useListUserCauseSelections();

  const myCauses = userCauseSelections?.map((selection) => {
    const { cause } = selection;

    return (
      <MyCauseCard
        causeId={cause.uuid}
        isSmallScreen
        enableSwipe={false}
        key={cause.uuid}
        title={cause?.name}
        src={cause?.logo?.url}
        onClick={() => {
          setMeta((prev) => ({ ...prev, causeId: cause.uuid }));
          openModalById('DonateCashback');
        }}
      />
    );
  });

  return (
    <Stack gap="sm">
      <Text fz="sm" fw="600">
        Select a cause
      </Text>
      {myCauses}
    </Stack>
  );
};

type SelectCauseModalProps = {
  opened: boolean;
  onClose: () => void;
  onSelectCauseClick: () => void;
  modalProps: Partial<ModalProps>;
};

/**
 * A modal that allows the user to select one of their favorited causes to donate to
 */
const SelectCauseModal = ({ opened, onClose, modalProps }: SelectCauseModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <TransferAccountModalTitleWithBackButton>
          Make a Donation
        </TransferAccountModalTitleWithBackButton>
      }
      {...modalProps}
    >
      <SelectCauseModalContent />
    </Modal>
  );
};

const SelectCauseModalWrapper = () => {
  const { openModalById, props, opened, closeAllModals } = useTransferAccountsModalGroupProvider({
    id: 'SelectCause',
  });

  return (
    <SelectCauseModal
      opened={opened}
      onClose={closeAllModals}
      onSelectCauseClick={() => openModalById('DonateCashback')}
      modalProps={props}
    />
  );
};

export { SelectCauseModalWrapper as SelectCauseModal };
